var React = require('react');

function CircleArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M11.11,7.83,8.35,10.59l-.53-.51L10,7.93H3.54V7.21H10L7.82,5.06l.53-.51,2.76,2.77.24.25Z","key":0}),React.createElement("path",{"d":"M15,7.57A7.5,7.5,0,1,1,7.5,0,7.53,7.53,0,0,1,15,7.57ZM.72,7.57a6.82,6.82,0,0,0,6.76,6.85A6.85,6.85,0,0,0,7.5.72,6.83,6.83,0,0,0,.72,7.57Z","key":1})]));
}

CircleArrowRight.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = CircleArrowRight;

CircleArrowRight.default = CircleArrowRight;
